// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import { EntityField } from '@types/entity/field/crud/field-crud-entity';
import JoditEditor from 'jodit-react';
import { ParseDateToEn } from 'helper/format-date-helper';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, FloatingLabel, Form, Row, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { BsAsterisk } from 'react-icons/bs';
import { RestUseCase } from '../../service/api/rest/rest-usecase';
import { UseAlert } from '../../hook/alert-hook';
import { getLocalStorage } from 'data/cache/localstorage-cache';
import { getEnv } from 'helper/window-helper';

type PropsField = {
  entityFields: EntityField[];
  changeField: any;
  inEditing?: boolean;
  onUploadPendingChange?: (pendente: boolean) => void;
};

const CreateFieldModalCrud: React.FC<PropsField> = ({
  entityFields,
  changeField,
  inEditing,
  onUploadPendingChange,
}: PropsField) => {

  /**
   *
   *
   *
   *
   *  alerta */
  const { showAlert } = UseAlert();

  /**
   *
   * EDITOR TEXT
   *
   */
  const editor = useRef(null);
  const entityFieldsRef = useRef(entityFields);
  entityFieldsRef.current = entityFields;
  const ignorarBlurConteudoVazioAteRef = useRef(0);
  const uploadMergeTimeoutRef = useRef<number | null>(null);

  const [midiaTutorialUploadEmAndamento, setMidiaTutorialUploadEmAndamento] =
    useState(false);

  function notificarUploadTutorialPendente(pendente: boolean) {
    setMidiaTutorialUploadEmAndamento(pendente);
    onUploadPendingChange?.(pendente);
  }

  function conteudoEditorPareceVazio(html: string) {
    const t = String(html ?? '')
      .trim()
      .replace(/\s/g, '');
    return (
      t === '' ||
      t === '<p></p>' ||
      t === '<p><br></p>' ||
      t === '<p><br/></p>' ||
      t === '<br>' ||
      t === '<br/>'
    );
  }

  function normalizarUrlUpload(resposta: string): string {
    let raw = (resposta || '').trim().replace(/^["']|["']$/g, '');
    if (!raw) return '';
    if (raw.startsWith('{') || raw.startsWith('[')) {
      try {
        const parsed = JSON.parse(raw);
        if (typeof parsed === 'string') return parsed.trim();
        if (parsed && typeof parsed === 'object') {
          const u =
            parsed.url ??
            parsed.Url ??
            parsed.link ??
            parsed.path ??
            parsed.fileUrl ??
            parsed.file_url ??
            parsed.data;
          if (typeof u === 'string' && u.trim()) return u.trim();
        }
      } catch {
        /* mantém raw */
      }
    }
    return raw;
  }

  function obterExtensaoDoArquivo(url: string, nomeArquivoOriginal?: string) {
    const pathSemQuery = url.split('?')[0].split('#')[0];
    const segmentos = pathSemQuery.split('.');
    const daUrl = segmentos.length > 1 ? segmentos[segmentos.length - 1].toLowerCase() : '';
    if (daUrl && daUrl.length <= 8 && !daUrl.includes('/') && !daUrl.includes('\\')) {
      return daUrl;
    }
    if (nomeArquivoOriginal) {
      const partes = nomeArquivoOriginal.split('.');
      return partes.length > 1 ? partes[partes.length - 1].toLowerCase() : '';
    }
    return daUrl;
  }

  function mimeVideoPorExtensao(ext: string): string {
    switch (ext) {
      case 'webm':
        return 'video/webm';
      case 'ogg':
      case 'ogv':
        return 'video/ogg';
      case 'mov':
        return 'video/quicktime';
      case 'avi':
        return 'video/x-msvideo';
      case 'mkv':
        return 'video/x-matroska';
      case 'm4v':
      case 'mp4':
      default:
        return 'video/mp4';
    }
  }

  function gerarHTMLPorExtensao(urlBruta: string, nomeArquivoOriginal?: string) {
    const url = normalizarUrlUpload(urlBruta);
    if (!url) {
      showAlert({
        show: true,
        content: 'Resposta do upload inválida',
        color: 'danger',
        time: 2000,
      });
      return '';
    }

    const extensao = obterExtensaoDoArquivo(url, nomeArquivoOriginal);

    switch (extensao) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'webp':
        return `<!-- IMAGEM COLOCADA VIA IS --><img src='${url}' alt='Imagem'>`;

      case 'pdf':
        return `<!-- PDF COLOCADA VIA IS --><a href='${url}' target='_blank' rel='noopener noreferrer'>Abrir PDF</a>`;

      case 'ppt':
      case 'pptx':
      case 'pptm':
        return `<!-- APRESENTACAO COLOCADA VIA IS --><a href='${url}' target='_blank' rel='noopener noreferrer'>Abrir apresentação (PowerPoint)</a>`;

      case 'xlsx':
      case 'xls':
        return `<!-- PLANILHA COLOCADA VIA IS --><a href='${url}' target='_blank' rel='noopener noreferrer'>Abrir Planilha</a>`;

      case 'mp4':
      case 'avi':
      case 'mov':
      case 'webm':
      case 'mkv':
      case 'm4v':
      case 'mpeg':
      case 'mpg':
      case 'ogv':
      case 'wmv': {
        const mime = mimeVideoPorExtensao(extensao);
        return `<!-- VIDEO COLOCADA VIA IS --><video width='320' height='240' controls><source src='${url}' type='${mime}'></video>`;
      }

      default:
        showAlert({
          show: true,
          content: `Tipo de arquivo não suportado no tutorial (.${extensao || '?'}). Use imagem, PDF, planilha, vídeo ou PowerPoint.`,
          color: 'danger',
          time: 3000,
        });
        return '';
    }
  }

  const [entity, updateEntity] = useState(entityFields);

  function appendUploadMediaToConteudo(uploadUrlRaw: string, nomeArquivoOriginal: string) {
    const fields = entityFieldsRef.current;
    if (!fields?.length) return;

    const urlNormalizada = normalizarUrlUpload(String(uploadUrlRaw));
    const htmlMidia = gerarHTMLPorExtensao(String(uploadUrlRaw), nomeArquivoOriginal);

    updateEntity(
      fields.map((element) => {
        if (element.name === 'Upload') {
          element.valueField = urlNormalizada || uploadUrlRaw;
        }
        if (element.name === 'conteudo' && htmlMidia) {
          element.valueField = (element.valueField || '') + htmlMidia;
        }
        return element;
      }),
    );
  }

  function handleOnChangeEditorText(event: any, name: string) {
    if (name === 'conteudo') {
      if (
        conteudoEditorPareceVazio(event) &&
        Date.now() < ignorarBlurConteudoVazioAteRef.current
      ) {
        return;
      }
    }

    const fields = entityFieldsRef.current;

    updateEntity(
      fields.map((element) => {
        if (element.name === name) {
          element.valueField = event;
        }
        return element;
      }),
    );
  }

  const handleOnChange = useCallback((event: any) => {
    event.preventDefault();
    const { name, value } = event.target;

    updateEntity(
      entityFields.map((element) => {
        if (element.name === name) element.valueField = value;
        return element;
      }),
    );
  }, []);

  const handleOnClick = useCallback((event: any) => {
    event.preventDefault();
    const { name, value } = event.target;

    console.log('handleOnClick > event.target ->', event.target);
    console.log('handleOnClick > name ->', name);
    console.log('handleOnClick > value ->', value);

    updateEntity(
      entityFields.map((element) => {
        if (element.name === name) {
          element.valueField = value;
        }
        return element;
      }),
    );

  }, []);

  const [contentFile, updateContentFile] = useState<File | undefined>();
  const [nameContentFile, updateNameContentFile] = useState<any>(null);
  const uploadFile = async (file: File) => {

    const timestampAtual: number = new Date().getTime();
    const TOKEN_USER_LOGIN = getEnv('REACT_APP_LOCALSTORAGE_TOKEN_USER_LOGIN')!;
    const ENDPOINT_CRUD = getEnv('REACT_APP_END_POINT_HELP')!;
    const REACT_APP_API_BACKEND = getEnv("REACT_APP_API_BACKEND")

    const tokenLocalStorageLogin: {
      token: string
    } =
      getLocalStorage(TOKEN_USER_LOGIN);

    var myHeaders = new Headers();
    myHeaders.append('accept', '*/*');
    myHeaders.append('Authorization', `Bearer ${tokenLocalStorageLogin.token}`)

    var formdata = new FormData();
    formdata.append('file', file, `${timestampAtual}_${file.name}`);

    var requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
    };

    return await fetch(`${REACT_APP_API_BACKEND}${ENDPOINT_CRUD}/upload_file`, requestOptions)
      .then(response => response.text())
      .then(result => {
        updateNameContentFile(result);
        return result;
      })
      .catch(error => {
        showAlert({
          show: true,
          content: 'Ops!!! Algo deu errado',
          color: 'danger',
          time: 2000,
        });
        console.log('showAlert');
        console.log('error', error);
      });
  };

  const handleOnChangeFile = async (event: any) => {
    event.preventDefault();
    const { name } = event.target;

    if (event.target.files !== null) {
      const file = event.target.files![0];

      if (name === 'Upload') {
        if (uploadMergeTimeoutRef.current !== null) {
          window.clearTimeout(uploadMergeTimeoutRef.current);
          uploadMergeTimeoutRef.current = null;
        }
        ignorarBlurConteudoVazioAteRef.current = Date.now() + 2000;
        notificarUploadTutorialPendente(true);
      }

      const result = await uploadFile(file);

      if (result !== undefined) {
        updateContentFile(file);

        if (name === 'Upload') {
          uploadMergeTimeoutRef.current = window.setTimeout(() => {
            uploadMergeTimeoutRef.current = null;
            appendUploadMediaToConteudo(result, file.name);
            notificarUploadTutorialPendente(false);
          }, 150);
        } else {
          updateEntity(
            entityFieldsRef.current.map((element) => {
              if (element.name === name) {
                element.valueField = file;
              }
              return element;
            }),
          );
        }
      } else {
        if (name === 'Upload') {
          notificarUploadTutorialPendente(false);
        }
        showAlert({
          show: true,
          content: 'Ops!!! Algo deu errado',
          color: 'danger',
          time: 2000,
        });
      }
    }
  };

  const handleOnChangeSelect = useCallback((params: any, name: string) => {
    updateEntity(
      entityFields.map((element) => {
        if (element.name === name) element.valueField = params.value;
        return element;
      }),
    );
  }, []);

  useEffect(() => {
    return () => {
      if (uploadMergeTimeoutRef.current !== null) {
        window.clearTimeout(uploadMergeTimeoutRef.current);
        uploadMergeTimeoutRef.current = null;
      }
      onUploadPendingChange?.(false);
    };
  }, [onUploadPendingChange]);

  useEffect(() => {
    changeField(entity);
  }, [entity]);

  const CreateField = () => {
    const listFields: React.ReactElement[] = [];

    entityFields.map((element, index) => {
      let disabled = false;

      if (inEditing) {
        disabled = element.labelFieldDisable === true ? true : false;
      }

      if (element.hideFieldOnCreate && !inEditing) {
        listFields.push(
          <Form.Control
            type='hidden'
            key={index}
            value={element.valueField}
          />,
        );
      } else {
        if (element.hideFieldOnEdit && inEditing) {
          listFields.push(
            <Form.Control
              type='hidden'
              key={index}
              value={element.valueField}
            />,
          );
        } else {
          if (element.typeField === 'hidden')
            listFields.push(
              <Form.Control
                type='hidden'
                key={index}
                value={element.valueField}
              />,
            );

          if (
            element.typeField === 'text' ||
            element.typeField === 'date'
          ) {
            let value = element.valueField;

            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  {element.labelField}
                  {element.required ? <BsAsterisk /> : ``}
                </Form.Label>
                <Col>
                  <Form.Control
                    name={element.name}
                    type={element.typeField}
                    onBlur={(event) => {
                      handleOnChange(event);
                    }}
                    defaultValue={value}
                    disabled={disabled}
                  />
                </Col>
              </Col>,
            );
          }

          if (element.typeField === 'number') {
            let value = element.valueField;

            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  {element.labelField}
                  {element.required ? <BsAsterisk /> : ``}
                </Form.Label>
                <Col>
                  <Form.Control
                    name={element.name}
                    type={element.typeField}
                    onBlur={(event) => {
                      if (event.target.value) {
                        if (
                          Number(event.target.value) >
                          9999999.99
                        ) {
                          event.target.value =
                            '9999999.99';
                          handleOnChange(event);
                        } else {
                          handleOnChange(event);
                        }
                      }
                    }}
                    defaultValue={value}
                    disabled={disabled}
                    maxLength={7}
                  />
                </Col>
              </Col>,
            );
          }

          if (element.typeField === 'text-area') {
            let value = element.valueField;

            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  {element.labelField}
                </Form.Label>
                <Col>
                  <Form.Control
                    name={element.name}
                    as='textarea'
                    type={element.typeField}
                    onBlur={handleOnChange}
                    defaultValue={value}
                  />
                </Col>
              </Col>,
            );
          }

          if (element.typeField === 'html') {
            let value = element.valueField;

            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  {element.labelField}
                </Form.Label>
                <Col>
                  <JoditEditor
                    ref={editor}
                    value={value}
                    onBlur={(event) =>
                      handleOnChangeEditorText(
                        event,
                        element.name,
                      )
                    }
                    config={{
                      processPasteFromWord: true,
                      processPasteHTML: false,
                      memorizeChoiceWhenPasteFragment: true,
                      buttons: [
                        'source',
                        '|', 'bold', 'italic',
                        '|', 'ul', 'ol',
                        '|', 'font', 'fontsize', 'brush', 'paragraph',
                        '|', 'video', 'table', 'link',
                        '|', 'left', 'center', 'right', 'justify',
                        '|', 'undo', 'redo',
                        '|', 'hr', 'eraser', 'fullsize',
                      ],
                    }}
                  />
                </Col>
              </Col>,
            );
          }

          if (element.typeField === 'radio')
            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  {element.labelField}
                </Form.Label>
                {element.listValueField!.map(
                  (el: any, i: number) => {
                    return (
                      <Form.Check
                        key={i}
                        inline
                        label={el.label}
                        name={element.name}
                        type='radio'
                        onChange={handleOnChange}
                        checked={
                          element.valueField ===
                            el.value
                            ? true
                            : false
                        }
                        value={el.value}
                      />
                    );
                  },
                )}
              </Col>,
            );

          if (element.typeField === 'select') {
            const options = element.listValueField;
            let valueField = element.valueField;

            let optionSelected = options?.filter((value) => {
              if (value.value === valueField) return value;
            })[0];

            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  {element.labelField}
                </Form.Label>
                <Select
                  options={options}
                  defaultValue={optionSelected}
                  onChange={(val) =>
                    handleOnChangeSelect(val!, element.name)
                  }
                  isDisabled={disabled}
                />
              </Col>,
            );
          }

          if (element.typeField === 'button') {
            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1'>
                  &ensp;
                </Form.Label>
                <Col>
                  <Button name={element.name} onClick={handleOnClick}>{element.name}</Button>
                </Col>
              </Col>,
            );
          }

          if (element.typeField === 'file') {
            const uploadTutorialCarregando =
              element.name === 'Upload' && midiaTutorialUploadEmAndamento;

            listFields.push(
              <Col md={element.sizeField} key={index}>
                <Form.Label className='m-1 d-flex align-items-center gap-2'>
                  {uploadTutorialCarregando ? (
                    <>
                      <Spinner animation='border' size='sm' role='status' />
                      <span className='small text-muted'>Enviando mídia…</span>
                    </>
                  ) : (
                    <>&ensp;</>
                  )}
                </Form.Label>
                <Col>
                  <Form.Control
                    name={element.name}
                    type={element.typeField}
                    onChange={handleOnChangeFile}
                    disabled={uploadTutorialCarregando}
                  />
                </Col>
              </Col>,
            );
          }

        }
      }

      return <></>;
    });

    return <Row>{listFields}</Row>;
  };

  return <CreateField />;
};

export default CreateFieldModalCrud;
